export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14446.cfd86b95.jpg";